<div
  class="container"
  [ngClass]="{
    'open-container':
      isExpanded && inputData.isExpandable && getControl.value === true,
  }"
  [formGroup]="form"
>
  <app-form-checkbox
    [formControl]="getControl"
    [label]="inputData.label"
    [isDisabled]="disable"
    (valueChanged)="updateValue($event)"
  >
  </app-form-checkbox>
  <div class="icon-container">
    <div class="icon">
      @if (inputData.hasTooltip) {
        <ion-icon
          #tooltip="matTooltip"
          class="icon"
          name="help-circle-outline"
          [matTooltip]="inputData.tooltipText"
          [matTooltipPosition]="'above'"
        ></ion-icon>
      }
    </div>
    @if (getControl.value === true && inputData.isExpandable) {
      <div class="icon">
        @if (!isExpanded) {
          <ion-icon
            name="add-outline"
            class="icon-expandable"
            (click)="clickExpand()"
          ></ion-icon>
        }
        @if (isExpanded) {
          <ion-icon
            name="remove-outline"
            class="icon-expandable"
            (click)="clickExpand()"
          ></ion-icon>
        }
      </div>
    }
  </div>
</div>

@if (getControl.value === true && inputData.isExpandable && isExpanded) {
  <div class="ion-margin-bottom">
    <ng-content></ng-content>
  </div>
}
